<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md="6" :sm="8">
            <a-form-item
              :label="$t(I18N_KEY.PLATFORMCOLLECTION + 'date')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 14, offset: 1 }"
            >
              <a-range-picker v-model="queryParam.queryDate" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.PLATFORMCOLLECTION + 'answered')">
              <a-select default-value=null style='width: 120px' v-model='queryParam.answered'>
                <a-select-option :value=null>
                  全部
                </a-select-option>
                <a-select-option :value="0">
                  未接听
                </a-select-option>
                <a-select-option :value="1">
                  已接听
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.PLATFORMCOLLECTION + 'callLogType')">
              <a-select default-value=null style='width: 120px' v-model='queryParam.callLogType'>
                <a-select-option :value=null>
                  全部
                </a-select-option>
                <a-select-option :value="1">
                  电销
                </a-select-option>
                <a-select-option :value="2">
                  催收
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <!--        <template slot='direction' slot-scope='text, record'>-->
        <!--          <div v-if='text == 1'>-->
        <!--            呼出-->
        <!--          </div>-->
        <!--          <div v-else>-->
        <!--            呼入-->
        <!--          </div>-->
        <!--        </template>-->
        <template slot='isAnswerRecord' slot-scope='text'>
          <div v-if='text == 0'>
            未接听
          </div>
          <div v-else>
            已接听
          </div>
        </template>

        <template slot='directionRecord' slot-scope='text'>
          <div v-if='text == 0'>
            呼入
          </div>
          <div v-else-if='text == 1'>
            呼出
          </div>
          <div v-else>
            AICC
          </div>
        </template>

        <template slot='hangupByRecord' slot-scope='text'>
          <div v-if='text == 0'>
            客服挂断
          </div>
          <div v-else-if='text == 1'>
            用户挂断
          </div>
          <div v-else>
            未知
          </div>
        </template>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getCallNxForTel } from '@/webpublicapi/collection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import OrderDetail from '@/views/webpublic/order/OrderDetail.vue'
import vModal from '@/views/webpublic/modules/Modal.vue'

const I18N_KEY = {
  PLATFORMCOLLECTION: 'platformCollection.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    vModal, OrderDetail,
    Dict,
    DictSelect
  },
  data() {
    return {
      paramsVal: {},
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      queryParam: {
        answered: null,
        callLogType: null
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'userNo'),
          align: 'center',
          dataIndex: 'mobile'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'agentName'),
          align: 'center',
          dataIndex: 'agentName'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'agentNickname'),
          align: 'center',
          dataIndex: 'agentNickname'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'answered'),
          align: 'center',
          dataIndex: 'answered',
          scopedSlots: { customRender: 'isAnswerRecord' } 
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'answerTime'),
          align: 'center',
          dataIndex: 'answerTime'

        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'callDuration'),
          align: 'center',
          dataIndex: 'callDuration'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'direction'),
          align: 'center',
          dataIndex: 'direction',
          scopedSlots: { customRender: 'directionRecord' } 
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'endTime'),
          align: 'center',
          dataIndex: 'endTime'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'hangupBy'),
          align: 'center',
          dataIndex: 'hangupBy',
          scopedSlots: { customRender: 'hangupByRecord' } 
        },
        // {
        //   title: '挂断原因码',
        //   align: 'center',
        //   dataIndex: 'hangupCode'
        // },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'callStatus'),
          align: 'center',
          dataIndex: 'callStatus'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'hangupReason'),
          align: 'center',
          dataIndex: 'hangupReason'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'recordUrl'),
          align: 'center',
          dataIndex: 'recordUrl'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'ringDuration'),
          align: 'center',
          dataIndex: 'ringDuration'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'ringTime'),
          align: 'center',
          dataIndex: 'ringTime'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'startTime'),
          align: 'center',
          dataIndex: 'startTime'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'totalCustomerPrice'),
          align: 'center',
          dataIndex: 'totalCustomerPrice'
        },
        {
          title: this.$t(I18N_KEY.PLATFORMCOLLECTION + 'hangupCause'),
          align: 'center',
          dataIndex: 'hangupCause'
        }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {

    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      var params = this.getQueryParams();
      if (params == null) {

      } else {
        this.loading = true
        getCallNxForTel(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            console.log('res------->', res)
            this.dataSource = res.data.list
            this.total = res.data.total
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { queryDate } = this.queryParam;
      const data = {
        ...this.queryParam,
        queryStartDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[0]) : null,
        queryEndDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[1]) : null
      }
      delete data.queryDate;
      this.paramsVal = {
        ...data
      }
      //分页参数
      this.paramsVal.pageNum = this.form.pageNum
      this.paramsVal.pageSize = this.form.pageSize
      delete this.paramsVal.orderGenerationDate
      return filterObj(this.paramsVal)
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.queryDate = null;
      that.queryParam.answered = null;
      that.queryParam.callLogType = null;
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .ant-modal {
  width: 600px !important;
}
</style>
